<template>

  <div class="company-info-management pl-60 pr-60 pt-20">

    <a-row class="mb-20">
      <a-col :offset="1"><span class="fs-24  mb-20">公司信息</span>  <span class="f-c-red ml-10">标* 为必填项 </span></a-col>
    </a-row>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form1" :rules="loginRules1">
      <a-form-model-item prop="companyName" label="公司名称">
        <a-input v-model="form1.companyName" placeholder="请填写公司名称" />
      </a-form-model-item>
      <a-form-model-item prop="industry" label="所属行业">
        <a-select
          v-model="form1.industry"
          show-search
          placeholder="请选择所属行业"
          class="w-100p"
        >
          <a-select-option v-for="i in industryList" :key="i.code" :value="JSON.stringify(i)">
            {{ i.desc }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="staffRange" label="人员规模">
        <a-select
          v-model="form1.staffRange"
          show-search
          placeholder="请选择所属行业"
          class="w-100p"
        >
          <a-select-option v-for="i in staffRangeList" :key="i.code" :value="JSON.stringify(i)">
            {{ i.desc }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="companyAddr" label="公司地址">
        <Addr :result.sync="form1.companyAddr" />
      </a-form-model-item>

      <a-form-model-item label="公司LOGO">
        <a-upload
          :action="uploadURL"
          list-type="picture-card"
          :file-list="fileList1"
          :headers="{token:$getToken()}"
          :before-upload="beforeUpload1"
          @preview="handlePreview"
          @change="handleChange1"
        >
          <div v-if="fileList1.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传图片
            </div>
          </div>
        </a-upload>

      </a-form-model-item>
      <a-form-model-item label="营业执照">
        <a-upload
          :action="uploadURL"
          list-type="picture-card"
          :file-list="fileList2"
          :headers="{token:$getToken()}"
          :before-upload="beforeUpload2"
          @preview="handlePreview"
          @change="handleChange2"
        >
          <div v-if="fileList2.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上传图片
            </div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item prop="username" label="企业账号">
        <a-input v-model="form1.username" placeholder="请输入4位以上的字母或数字组合" :readonly="resData.username?true:false" />
      </a-form-model-item>
      <a-form-model-item prop="password" label="企业密码">
        <a-input-password ref="pass" v-model="form1.password" placeholder="请输入企业密码" @focus="passFocus" />
      </a-form-model-item>

      <a-row class="mb-20">
        <a-col :offset="1"><span class="fs-24  mb-20">管理员信息</span>  <span class="f-c-red ml-10">* 务必填写真实有效的联系人信息，用于资金对账、开票、寄件服务的主要对接人。 </span></a-col>
      </a-row>
      <a-form-model-item prop="adminName" label="管理员姓名">
        <a-input v-model="form1.adminName" placeholder="请填写管理员姓名" />
      </a-form-model-item>
      <a-form-model-item prop="adminPhone" label="管理员电话">
        <a-input v-model="form1.adminPhone" placeholder="请填写手机号" />
      </a-form-model-item>
      <a-form-model-item prop="adminEmail" label="管理员邮箱">
        <a-input v-model="form1.adminEmail" placeholder="请填写有效的Email" />
      </a-form-model-item>
      <a-form-model-item prop="contactQQ" label="管理员QQ">
        <a-input v-model="form1.contactQQ" placeholder="请填写有效的管理员QQ" />
      </a-form-model-item>
      <a-form-model-item prop="contactWX" label="管理员微信">
        <a-input v-model="form1.contactWX" placeholder="请填写有效的管理员微信" />
      </a-form-model-item>
      <a-row class="mt-20 mb-20">
        <a-col :offset="4">  <a-button
          type="primary"
          :loading="formLoading"
          :disabled="uploading1||uploading2"
          @click="postForm1"
        >
          保存
        </a-button></a-col>
      </a-row>
    </a-form-model>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img style="width: 100%" :src="previewImage">
    </a-modal>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
import validate from '@framework/utils/biz-validate'
import Addr from '@/components/addr'
import { getToken, setToken } from '@framework/utils/auth' // get token from cookie
export default {
  components: {
    Addr
  },

  data() {
    const validateEmail = (rule, value, callback) => {
      if (!validate.email.pattern.test(value)) {
        callback(new Error(validate.email.msg))
      } else {
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      if (!validate.mobile.pattern.test(value)) {
        callback(new Error(validate.mobile.msg))
      } else {
        callback()
      }
    }

    const validateAddr = (rule, value, callback) => {
      if (!value || !value.provinceCode) {
        callback(new Error('请选择省市区'))
      } else if (!value || !value.addressDetail) {
        callback(new Error('请填写详细地址'))
      } else {
        callback()
      }
    }
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },

      previewImage: '',
      previewVisible: false,
      uploadURL: process.env.VUE_APP_BASE_API + '/upload/singleFile.json',
      fileList1: [],
      fileList2: [],
      loginRules1: {
        companyAddr: [
          { required: true, trigger: 'change', validator: validateAddr }
        ],
        adminPhone: [
          { required: true, trigger: 'change', validator: validateMobile }
        ],

        companyName: [
          { required: true, trigger: 'change', message: '请填写公司名称' }
        ],
        adminName: [
          { required: true, trigger: 'change', message: '请填写管理员姓名' }
        ],
        industry: [
          { required: true, trigger: 'change', message: '请选择所属行业' }
        ],
        staffRange: [
          { required: true, trigger: 'change', message: '请选择人员规模' }
        ],
        adminEmail: [
          { required: true, trigger: 'change', validator: validateEmail }
        ],
        username: [
          { required: true, trigger: 'change', message: '请输入企业账号' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{4,20}$/, message: '请输入4位以上字母数字组合' }
        ],
        password: [{ required: true, message: '请输入企业密码' }]

      },
      visible: this.viz,
      confirmLoading: false,
      form1: {
        industry: undefined,
        'companyName': '',
        'companyAddr': null,
        'adminName': '',
        'adminPhone': '',
        'adminEmail': '',
        staffRange: undefined,
        companyLogo: '',
        companyPicture: '',
        contactQQ: '',
        contactWX: '',
        username: '',
        password: '******'
      },
      resData: {},
      formLoading: false,
      industryList: [],
      staffRangeList: [],
      uploading1: false,
      uploading2: false
    }
  },

  async created() {
    const list1 = await this.$http(this.$api.enterpriseGetIndustryList)
    const list2 = await this.$http(this.$api.enterpriseGetStaffRangeList)
    this.industryList = list1 || []
    this.staffRangeList = list2 || []
    this.initData()
  },
  mounted() {
    const node = document.getElementsByClassName('ant-input-suffix')[0]
    const inp = this.$refs.pass
    if (node) {
      node.addEventListener('click', () => {
        inp.focus()
      })
    }
  },
  methods: {
    beforeUpload1(arg) {
      this.uploading1 = true
    },
    beforeUpload2(arg) {
      this.uploading2 = true
    },
    async initData() {
      const info = await this.$http(this.$api.enterpriseGetInfo) || {}
      this.resData = info
      this.form1.contactWX = info.contactWX
      this.form1.contactQQ = info.contactQQ
      this.form1.companyName = info.companyName
      this.form1.adminName = info.contactName
      this.form1.adminEmail = info.contactEmail
      this.form1.adminPhone = info.contactMobile
      this.form1.username = info.username
      // 地址
      if (info.companyProvinceCode) {
        this.form1.companyAddr = {
          addressDetail: info.companyAddress,
          areaName: info.companyAreaName,
          cityName: info.companyCityName,
          provinceName: info.companyProvinceName,
          areaCode: info.companyAreaCode,
          cityCode: info.companyCityCode,
          provinceCode: info.companyProvinceCode
        }
      }
      const industry = this.industryList.find(el => el.code === info.industry)
      const staffRange = this.staffRangeList.find(el => el.code === info.staffRange)
      if (industry) {
        this.form1.industry = JSON.stringify(industry)
      }
      if (staffRange) {
        this.form1.staffRange = JSON.stringify(staffRange)
      }
      if (info.companyLogo) {
        this.fileList1 = [{
          uid: info.companyLogo,
          name: info.companyLogo,
          status: 'done',
          url: info.companyLogo
        }]
        this.form1.companyLogo = info.companyLogo
      }
      if (info.companyPicture) {
        this.fileList2 = [{
          uid: info.companyPicture,
          name: info.companyPicture,
          status: 'done',
          url: info.companyPicture
        }]
        this.form1.companyPicture = info.companyPicture
      }
    },
    passFocus() {
      if (this.form1.password === '******') {
        this.form1.password = ''
      }
    },
    close() {
      this.visible = false
    },
    show() {
      this.visible = true
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange1({ fileList }) {
      this.fileList1 = fileList
      if (fileList[0] && fileList[0].response && fileList[0].response.data.success) {
        this.form1.companyLogo = fileList[0].response.data.filePath
      } else {
        this.form1.companyLogo = ''
      }
      this.uploading1 = false
    },
    handleChange2({ fileList }) {
      this.fileList2 = fileList
      if (fileList[0] && fileList[0].response && fileList[0].response.data.success) {
        this.form1.companyPicture = fileList[0].response.data.filePath
      } else {
        this.form1.companyPicture = ''
      }
      this.uploading2 = false
    },
    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          try {
            const data = {
              'companyAddress': this.form1.companyAddr.addressDetail,
              'companyArea': this.form1.companyAddr.areaName,
              'companyCity': this.form1.companyAddr.cityName,
              'companyProvince': this.form1.companyAddr.provinceName,
              'companyAreaCode': this.form1.companyAddr.areaCode,
              'companyCityCode': this.form1.companyAddr.cityCode,
              'companyProvinceCode': this.form1.companyAddr.provinceCode,
              'companyName': this.form1.companyName,
              'contactEmail': this.form1.adminEmail,
              'contactMobile': this.form1.adminPhone,
              'contactName': this.form1.adminName,
              staffRange: JSON.parse(this.form1.staffRange).code,
              companyLogo: this.form1.companyLogo,
              companyPicture: this.form1.companyPicture,
              contactQQ: this.form1.contactQQ,
              contactWX: this.form1.contactWX,
              industry: JSON.parse(this.form1.industry).code,
              username: this.form1.username,
              password: this.form1.password,
              id: this.resData.id
            }
            if (data.password === '******') {
              data.password = ''
            }
            if (!this.resData.id) {
              delete data.id
            }
            const res = await this.$http(this.$api.enterpriseEdit, data)
            if (res === null) {
              this.$message.success('保存成功')
            } else {
              this.$message.success('保存成功')
              setToken(res)
              setTimeout(() => {
                this.$store.dispatch('user/getInfo')
              }, 100)
            }
            this.formLoading = false
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="scss">

</style>
